'use client';

import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@mui/material';
import { forwardRef } from 'react';

export type MenuItemProps = MuiMenuItemProps & {
  /**
   * 自定义高度，默认为40px
   */
  customHeight?: string | number;
};

/**
 * MenuItem组件，封装MUI的MenuItem组件
 * 默认高度为40px
 */
const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => {
  const { children, customHeight, sx, ...otherProps } = props;

  return (
    <MuiMenuItem
      ref={ref}
      sx={{
        height: customHeight || '40px',
        lineHeight: '18px',
        '&:hover': {
          backgroundColor: '#edecfd',
        },
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </MuiMenuItem>
  );
});

MenuItem.displayName = 'MenuItem';

export default MenuItem;
